import PropTypes from 'prop-types'
import React from 'react'
import classes from './Login.scss'

import { add as addNotification } from 'store/reducers/notifications'
import { show } from 'store/reducers/modals'

import Button from 'components/Button'
import Input from 'components/Form/Input'

export class Login extends React.Component {
  openPasswordlessModal = e => {
    e && e.preventDefault()
    const email = this.props.fields.email.value

    this.props.passwordless(email)
    this.props.dispatch(show('passwordless', { props: { email: this.props.fields.email.value } }))
  };

  componentDidMount () {
    if (this.props.fields.email.value && this.props.fields.magic_token.value) {
      this.props.dispatch(addNotification('Trying to log you in with that auto-login link.', 'notice'))
      setTimeout(() => this.props.handleSubmit(this.props.onSubmit), 10) // super hack as redux-form sucks and doesn't work yet
    }
  }

  render () {
    return <form onSubmit={this.props.handleSubmit} className={classes['form']} ref={ref => (this.form = ref)}>
      <fieldset>
        <div className={classes['legend--center']}>Please Login to TwoXSea</div>
        <Input type='hidden' {...this.props.fields.magic_token} />

        <Input label='Email' type='email' placeholder='email address' {...this.props.fields.email} />
        <Input label='Password' type='password' placeholder='password'
          options={['block', 'password']}
          {...this.props.fields.password}
          note={<div className={classes.magic}>
            <small>Forgot your password?</small>

            <br /><br />
            {(!this.props.fields.email.value || this.props.fields.email.error) && `Enter your email address above.` ||
              <Button callback={this.openPasswordlessModal} options={['blue']}>
                Login via Email
              </Button>
            }
          </div>}
        />

        <footer className={classes['footer']}>
          <Button submit options={['green', 'large', 'block']}>
            Login
          </Button>
        </footer>
      </fieldset>
    </form>
  }
}

Login.propTypes = {
  onSubmit: PropTypes.func, // actual submit function
  handleSubmit: PropTypes.func.isRequired, // redux-form function
  fields: PropTypes.object.isRequired,
  passwordless: PropTypes.func,

  dispatch: PropTypes.func.isRequired
}

export default Login



// WEBPACK FOOTER //
// ./src/components/Login/Login.js